<script setup>
  import { defineProps, ref } from 'vue';
  import { Format } from '@/format';
  import { Fabric } from '@/fabrics';

  const isOpen = ref(false);
  const props = defineProps(['data']);

  function toggleAccordion() {
    isOpen.value = !isOpen.value;
  }

  function formatCamelCase(input) {
    // Translate fabric SKUs
    const fabricName = Fabric.getFabricNameBySKU(input);
    if (fabricName !== input) {
      return fabricName;
    }

    const hardwareName = Fabric.getHardwareNameBySKU(input);
    if (hardwareName !== input) {
      return hardwareName;
    }

    // Handle numeric values: numbers or numeric strings
    if (typeof input === 'number' || (typeof input === 'string' && input.trim().match(/^-?\d+(\.\d+)?$/))) {
      const num = parseFloat(input);
      return !isNaN(num) ? `${num}"` : String(input);
    }

    // If not a string, return unchanged
    if (typeof input !== 'string') {
      return input;
    }

    // Exception map for specific productType values
    const exceptions = {
      cafeCurtains: 'Café Curtains',
      fabricSKU: 'Fabric',
      sheersSKU: 'Sheers',
      RS: 'Roman Shades',
      WW: 'Woven Woods',
      matteBlack: 'Black',
      single: 'Single Rod',
      double: 'Double Rod',
      split: 'Split Panel (Pair)',
      four: 'Four Panel (Two-Pair)',
      six: 'Six Panel (Three-Pair)',
      inside: 'Inside Mount',
      outside: 'Outside Mount',
      motorType: '',
      gaposa: '',
      shadeProductType: 'Product',
      shadeStyleType: 'Style',
      shadeConstructionType: 'Shade Operation',
      mountPositionType: 'Mount Position',
      liningType: 'Lining',
      liftMechanismType: 'Custom Control',
      controlPostionType: 'Control Position',
      standard: 'Back',
      cordForwardOutside: 'Front',
      cordForwardInside: 'Front',
      continuousChain: 'Chain Loop',
      motorized: 'Motorization',
      productType: 'Product',
      pleatStyleType: 'Pleat Style',
      panelConfigurationType: 'Panel Configuration',
      fauxPanelStyleType: 'Standard or Faux',
      hardwareFinishType: 'Hadware Finish',
      hardwareStyleType: 'Hardware Style',
      ringStyleType: 'Ring Style',
      brackStyleType: 'Bracket Style',
      rodConstructionType: 'Rod Construction',
      rodSizeType: 'Rod Size',
      centerBracketType: 'Center Bracket',
      supportBracketType: 'Support Bracket'
    };

    // Drapery Rules:
    // Bracket Style Type and Rod Style can go away,

    if (input in exceptions) {
      return exceptions[input];
    }

    // Format camelCase
    const words = input
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .split(/(?=[A-Z])/g)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

    return words.join(' ');
  }

</script>

<template>
  <hr>

  <div class="order__product-item">
    <div class="order__product-item-header">
      <!-- <img :src="props.data.imageUrl"> -->
      <img class="order__product-item-img" src="https://cdn.shopify.com/s/files/1/0605/8049/5522/products/BOESS_box_blackout_no-sheers_rightAngle_matteBlack_box_f9604884-ab65-4da3-97c6-a2aad0086d6b.jpg?v=1657748429" alt="">

      <div class="order__product-item-title">
        <div>
          <h3 class="heading-3" v-if="props.data.windowName">{{ props.data.windowName }}</h3>
          <h5>{{ formatCamelCase(props.data.heading) }}</h5>
        </div>

        <div class="order__product-item-pricing">
          <div class="order__product">
            <label class="pretext">Price: </label>
            <span>{{ Format.asCurrency(props.data.cost) }}</span>
          </div>
          <div>
            <label class="pretext">Qty: </label>
            <span>{{ props.data.quantity }}</span>
          </div>
          <div>
            <label class="pretext">Total: </label>
            <span>{{ Format.asCurrency(props.data.totalCost) }}</span>
          </div>
        </div>

        <div class="order__product-item-content">
          <div class="accordion__product-header" @click="toggleAccordion">
            <h3 class="pretext color--lavaglas">Configuration Details</h3>
            <div class="accordion__icon"></div>
          </div>

          <transition name="accordion-slide">
            <div v-if="isOpen" class="accordion__product-content top-border">
              <div v-for="option in props.data.configuration" :key="option" class="accordion__product-item-wrapper">
                <label class="accordion__product-item pretext no--margin-b">{{ formatCamelCase(option.label) }}:</label>
                <span class="accordion__product-item ts--callout no--margin-b line-item__fabric">{{ formatCamelCase(option.value) }}</span>
              </div>
            </div>
          </transition>
        </div>

      </div>
    </div>
  </div>
</template>